import { SvgIcon, SvgIconProps } from '@mui/material';

const SaveOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="SaveOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 2C17.0853 2 17.6466 2.2326 18.0605 2.64648L21.1211 5.70703L21.3203 5.92676C21.7577 6.46028 22 7.13146 22 7.82812V19C21.9998 20.6564 20.657 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H16.5ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H6V13C6 11.8954 6.89543 11 8 11H16C17.1046 11 18 11.8954 18 13V20H19C19.5519 20 19.9998 19.5524 20 19V7.82812C20 7.59628 19.9195 7.3724 19.7734 7.19434L19.707 7.12109L16.6465 4.06055C16.6076 4.02173 16.5549 4 16.5 4H15V7C15 8.10457 14.1046 9 13 9H9C7.89543 9 7 8.10457 7 7V4H5ZM8 20H16V13H8V20ZM9 7H13V4H9V7Z"
      />
    </SvgIcon>
  );
};

export default SaveOutlined;
